import WarehouseInput from "@/widgets/Inputs/WarehouseInput.vue";

export default {
	data() {
		return {
			filterWarehouse: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterWarehouse._id": {
			handler(val) {
				// let fieldName = "warehouse";
				// if (val !== "") {
				// 	this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				// } else {
				// 	this.$delete(this.kvFilter, fieldName);
				// }
			},
			immediate: true
		}
	},
	components: {
		WarehouseInput
	}
};
